import { DiscoverySource, DiscoverySourceEntity } from '../..';
import { FirestoreEntity, Mapper } from '../../../@harmony';

export class DiscoverySourceToDiscoverySourceEntityMapper
  implements Mapper<DiscoverySource, FirestoreEntity<DiscoverySourceEntity>>
{
  public map(from: DiscoverySource): FirestoreEntity<DiscoverySourceEntity> {
    return new FirestoreEntity(from.id, {
      name: from.name,
    });
  }
}

export class DiscoverySourceEntityToDiscoverySourceMapper
  implements Mapper<FirestoreEntity<DiscoverySourceEntity>, DiscoverySource>
{
  public map(from: FirestoreEntity<DiscoverySourceEntity>): DiscoverySource {
    return new DiscoverySource(from.id, from.data.name);
  }
}
